"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const assets_1 = require("../../lib/assets");
function RecipeCard({ recipe }) {
    var _a, _b;
    return ((0, preact_1.h)("article", { className: 'card  card--recipe  align-center' },
        (0, preact_1.h)("div", { className: 'stack  card__zoom-container' },
            (0, preact_1.h)("img", { src: (_b = (_a = recipe.image) === null || _a === void 0 ? void 0 : _a.src) !== null && _b !== void 0 ? _b : (0, assets_1.asset)('images/placeholder/recipe.svg'), alt: '', width: 480, height: 400, className: 'card__image' })),
        (0, preact_1.h)("div", { className: 'card__content' },
            (0, preact_1.h)("div", { className: 'card__title  font-veneer  fg-red  tracking-wide' },
                (0, preact_1.h)("a", { href: `/recipes/${recipe.slug}`, className: 'fill-link  subtle-link' }, recipe.title)))));
}
exports.default = RecipeCard;
